import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  searchFacetChange,
  submitSearchFacet,
  updateFilterOption,
} from '../Actions/FacetedSearch.action';
import SideMenu from './SideMenu';
import FacetedSearch from './FacetedSearch';
import useIsMobile from '../Hooks/useIsMobile';
import { translate } from '../Services/translation';

const getSortCriteriaFilter = (sortItems) => ({
  id: 'sort',
  label: translate('filter.sorting'),
  options: sortItems.map((s) => ({
    id: s.value,
    label: s.text,
    singleSelect: true,
  })),
  selectedOptions:
    sortItems.filter((s) => s.selected).length == 0
      ? [sortItems[0].value]
      : sortItems.filter((s) => s.selected).map((s) => s.value),
});

export default ({ isOpen, onClosed }) => {
  const facetedSearchState = useSelector((state) => state.facetedSearch);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [currentFilterId, setCurrentFilterId] = useState();
  const [sortCriteriaFilter, setSortCriteriaFilter] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const filters = facetedSearchState.facetFilters;
  const currentFilter = currentFilterId
    ? currentFilterId == 'sort'
      ? sortCriteriaFilter
      : facetedSearchState.facetFilters.find((f) => f.id == currentFilterId)
    : null;
  const selectedOptionsCount = filters.reduce(
    (partialSum, group) => partialSum + group.selectedOptions.length,
    0
  );
  const clearSelectedFilters = () => {
    // Set all selectedOptions to an empty array
    setIsLoading(true);
    filters.forEach((f) => (f.selectedOptions = []));
    dispatch(submitSearchFacet(filters));
  };

  const onFilterChange = async (filter, option) => {
    setIsLoading(true);
    if (filter.id == 'sort') {
      window.location = option.id;
    } else {
      dispatch(searchFacetChange(filter, option));
    }
  };

  useEffect(() => {
    setIsLoading(false);

    if (
      facetedSearchState &&
      facetedSearchState.sortCriteria &&
      facetedSearchState.sortCriteria.sortItems
    ) {
      setSortCriteriaFilter(
        getSortCriteriaFilter(facetedSearchState.sortCriteria.sortItems)
      );
    }
  }, [facetedSearchState]);

  const footer = (
    <>
      <button
        className="btn btn--large btn--full  btn--black mobile-filter-menu__show-products-btn"
        onClick={onClosed}
        disabled={isLoading}
      >
        {!isLoading && (
          <>
            <span>
              {translate('global.show')} (
              {facetedSearchState.sortCriteria.productHits})
            </span>
          </>
        )}
        {isLoading && <i className="ph-arrow-clockwise spin"></i>}
      </button>
    </>
  );

  return (
    <SideMenu
      id="MobileFilterMenu"
      className="mobile-filter"
      header={
        <>
          {translate('mobile-filter-menu.title')}
          {selectedOptionsCount > 0 && (
            <div
              className="clear-filter-button"
              onClick={clearSelectedFilters}
              disabled={isLoading}
            >
              {translate('mobile-filter-menu.clear-filters').replace(
                '{0}',
                selectedOptionsCount
              )}
            </div>
          )}
        </>
      }
      footer={footer}
      from="left"
      open={isOpen}
      onClosed={onClosed}
    >
      <FacetedSearch />
    </SideMenu>
  );
};
